import React, { Component } from 'react';
import Site, {SiteModifier_} from '../utils/Site';

import {
  Link,
  withRouter
} from 'react-router-dom';

import Base from '../components/BaseComponent'
import Intro from '../components/Intro'
import Navigation from '../components/Navigation'
import Item from '../components/Item'
import Content from '../components/Content'
import Grid from '../components/Grid'
import Media from '../components/Media'
import Newsletter from '../components/Newsletter'
import Button from '../components/Button'
import Image from '../components/Image'
import FadeIn from '../components/FadeIn'
import Slider from '../components/Slider'
import MiniMap from '../components/MiniMap'
import Links from '../components/Link'
import Days from '../components/Days'
import NewsGroup from '../components/NewsGroup'
import ScrollTo from '../components/ScrollTo'
import Tidy from '../components/Tidy'


import Asset from '../models/Asset'
import Entry from '../models/Entry'

import withData from '../utils/withData';
import Window from '../utils/Window';

import moment from 'moment';
import 'moment-timezone';

import '../helpers/Array';

const timezone = 'America/New_York'

class Map extends Component {

	constructor(props) {
		super(props);
		this.state = {filter : (window.location.hash) ? window.location.hash.replace('#','') : 'date'};
	}

	componentDidMount() {

	}

	componentWillUnmount() {

	}

	getDate = (dateStr) => {
	    return moment(dateStr).format('ddd MM.DD');
	  }

	  getTime = (dateStr) => {
	    return moment(dateStr).format('h.mma');
	  }


	filter = (tag) => {

		this.setState({filter:tag});
	}

	getNewsList  = (articles) => {
		
		//Some global lookup data we need
		let {locations,entries} = this.props.data;

		let groups = []
		let groupKeys = []
		let currentGroup = null
		let today = parseInt(moment.tz(timezone).format('YYYYMMDD'))
		let yesterday = parseInt(moment.tz(new Date(),timezone).subtract(1,'days').format('YYYYMMDD'));

		switch(this.state.filter) {
			case 'type':

				articles.map(articleId => {

					let article = entries.find((entry) => (entry.id == articleId));

					let dateComp = parseInt(moment.tz(article.postDate,timezone).format('YYYYMMDD'))
					

						let cat = typeof article.newsCategory == 'string' ? article.newsCategory : article.newsCategory[0]
						let key = cat

					
						if(groupKeys.indexOf(key) < 0)
							{
								groupKeys.push(key)
								let label = key

								groups.push({
									key: key,
									label: label,
									items: [article]
								})
							} else {
								//find the group!
								currentGroup = groups.filter(group => group.key == key)
								currentGroup[0].items.push(article)
							}
					

				})

				// alphabetise the groups by key

				groups.sort(function(a, b)
				{
					return a.key > b.key
				})


				break
			case 'location':

				articles.map(articleId => {

					let article = entries.find((entry) => (entry.id == articleId));


					let dateComp = parseInt(moment.tz(article.postDate,timezone).format('YYYYMMDD'))
					if(article.location && article.location.length) {

						let location = entries.find((entry) => (entry.id == article.location[0]));
						if(location)
						{
							let key = location.title

						
							if(groupKeys.indexOf(key) < 0)
							{
								groupKeys.push(key)
								let label = key

								groups.push({
									key: key,
									label: label,
									items: [article]
								})
							} else {
								//find the group!
								currentGroup = groups.filter(group => group.key == key)
								currentGroup[0].items.push(article)
							}
						}
					}

				})

				// alphabetise the groups by key

				groups.sort(function(a, b)
				{
					return a.key > b.key
				})

				break
			case 'picks':

				articles.map(articleId => {

					let article = entries.find((entry) => (entry.id == articleId));
					if(article.ourPick == '1') {
						let key = article.postDate
						let dateComp = parseInt(moment.tz(key,timezone).format('YYYYMMDD'))

						
						
							if(groupKeys.indexOf(key) < 0)
							{
								groupKeys.push(key)
								if(currentGroup) groups.push(currentGroup)

								let label = this.getDate(key)

								if(dateComp == today) label = 'Today'
								if(dateComp == yesterday) label = 'Yesterday'

								currentGroup = {
									key: key,
									label: label,
									items: []
								}
							}

							currentGroup.items.push(article)

						
					}

				})

				groups.push(currentGroup)

				break
			default:

				articles.map(articleId => {

					let article = entries.find((entry) => (entry.id == articleId));
					let key = article.postDate
					let dateComp = parseInt(moment.tz(key,timezone).format('YYYYMMDD'))
					
						if(groupKeys.indexOf(key) < 0)
						{
							groupKeys.push(key)
							if(currentGroup) groups.push(currentGroup)

							let label = this.getDate(key)

							if(dateComp == today) label = 'Today'
							if(dateComp == yesterday) label = 'Yesterday'

							currentGroup = {
								key: key,
								label: label,
								items: []
							}
						}

						currentGroup.items.push(article)

					

				})

				groups.push(currentGroup)

				break
		}

		return groups.map((group,ix) => {
			return (<NewsGroup label={group.label} items={group.items} ix={ix} filter={this.state.filter} />)
		})


	}

	/*

		RENDER

	*/

	render() {

		const {entry} = this.props;
		//console.log('entry',entry);

		let hash = this.props.location.hash.replace('#','');
		if(!hash) hash = 'date';

		let news = (this.props.items) ? this.props.items : this.props.data.news;
		let features = (this.props.items) ? [...this.props.items].shuffle().limit(1) : entry.features;

		let dateActive = (hash == 'date') ? 'is-active' : null;
		let typeActive = (hash == 'type') ? 'is-active' : null;
		let locationActive = (hash == 'location') ? 'is-active' : null;
		let picksActive = (hash == 'picks') ? 'is-active' : null;


		return (
			<FadeIn>
			<ScrollTo pos={0}/>
			<div className="Template  Template--default  Template--news">

			{/* Template-intro */}
						<Window className="Template-intro">

							<Slider autoplay={true} delay={5000}>
								{entry.features.map((item,ix) => (
										<Entry id={[item]} render={ (slide) => (
										<Item modifiers={['intro']}>


												<Link to={slide.uri}>
												<div className="Item-head">
													<div className="Item-title">
														<Content modifier={'yellow'}>
															<Tidy html={'<h1>'+slide.title+'<h1>'}/>
														</Content>
													</div>
													<div className="Item-subTitle">
														<Content>
															<h4>{slide.newsCategory}</h4>
														</Content>
													</div>
												</div>
												</Link>

												<div className="Item-media">
													<Media id={slide.image[0]} />
												</div>


										</Item>
										)} />

								))}
							</Slider>

						</Window>
						{/* / Template-intro */}

					

					<div className="Template-body">

						<div className="Template-sections">
						<div className="Template-section Template-section--narrow  Template-section--first">
							<div className="Template-heading">
								<Content>
									<h1>{entry.title}</h1>
								</Content>
							</div>
							<div className="Template-content">

								<div className="Template-content-container">
									<ul className="List List--filters">
										<li onClick={() => (this.filter('date')) }><Link to={'#date'} className={'Link Link--filter '+dateActive}>By Date</Link></li>
										<li onClick={() => this.filter('type') }><Link to={'#type'} className={'Link Link--filter '+typeActive}>By Type</Link></li>
										<li onClick={() => this.filter('location') }><Link to={'#location'} className={'Link Link--filter '+locationActive}>By Location</Link></li>
										<li onClick={() => this.filter('picks') }><Link to={'#picks'} className={'Link Link--filter '+picksActive}>Our Picks</Link></li>
									</ul>
								</div>

							</div>
						</div>

						{this.getNewsList(news)}

						</div>
					</div>


			</div>
			</FadeIn>
		);

	}
}

export default withRouter(withData(Map));



// WEBPACK FOOTER //
// ./src/js/templates/News.js